import { Box, InputAdornment, TextField } from "@mui/material";
import { isNil } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../core/app/AppReducer";
import GreenRupee from "../../core/assets/oot/classic/Green_Rupee_Artwork.png";
import { setShopItem } from "../OotrReducer";
import OotItemContextMenuButton from "../hints/OotItemContextMenuButton";
import { DefaultDeadgeItem } from "../inventory/items/DeadgeItem";
const Shop = ["Kokiri Shop", "Bazaar Child", "Potion child", "Bazaar Adult", "Potion Adult", "Goron Shop", "Zora Shop", "Bombchus Shop"]

interface ShopsanityTrackerProps {
    shopOn?: true
}

const ShopsanityTracker = (props: ShopsanityTrackerProps) => {

    let shopsanity = useSelector((state: AppState) => state.ui.ootr.main.useShopsanity)

    if(props.shopOn)
        shopsanity = true;

    if (!shopsanity)
        return null;
    return <Box display="flex" flexDirection={"column"} textAlign={"center"}>
        {Shop.map((s, i) => {
            return <ShopTrack shopName={s} id={i} />
        })}
    </Box>
}

export default ShopsanityTracker;


interface ShopTrackProps {
    shopName: string,
    id: number
}

const ShopTrack = (props: ShopTrackProps) => {


    // let [isDead, setIsDead] = useState<boolean>(false)
    let dispatch = useDispatch();


    return <Box display="flex" flexDirection={"row"} flexBasis={"fit-content"} justifyContent={"space-around"} textAlign={"start"}>
        <Box display={"flex"} width={"100px"} onDoubleClick={() => {
            dispatch(setShopItem({ item: DefaultDeadgeItem, shop: props.shopName, itemid: 0, price: 0 }))
            dispatch(setShopItem({ item: DefaultDeadgeItem, shop: props.shopName, itemid: 1, price: 0 }))
            dispatch(setShopItem({ item: DefaultDeadgeItem, shop: props.shopName, itemid: 2, price: 0 }))
            dispatch(setShopItem({ item: DefaultDeadgeItem, shop: props.shopName, itemid: 3, price: 0 }))
        
        }} >{props.shopName}</Box>
        <Box display={"flex"}>
            {Array.from(Array(4).keys()).map(i => {
                return <ShopTrackItem shopName={props.shopName} itemid={i}  />
            })}
            <OotItemContextMenuButton />
            <OotItemContextMenuButton />
        </Box>

    </Box>
}

interface ShopTrackItemProps {
    shopName: string,
    itemid: number
}

const ShopTrackItem = (props: ShopTrackItemProps) => {

    let dispatch = useDispatch();
    let shop = useSelector((state: AppState) => state.ui.ootr.main.shops)

    if (isNil(shop[props.shopName]))
        dispatch(setShopItem({ item: null, shop: props.shopName, itemid: 1, price: null }))

    let shopitem = shop[props.shopName][props.itemid];

    return <Box display={"flex"} flexDirection={"row"} flexBasis={"fit-content"}>
        <OotItemContextMenuButton item={shopitem.item} onItemChange={(i) => dispatch(setShopItem({ item: i, shop: props.shopName, itemid: props.itemid, price: shopitem.price }))} />
        <TextField InputProps={{
            startAdornment: (<InputAdornment position="start">
                <img src={GreenRupee} alt="" width={"10px"} height={"15px"}></img>
            </InputAdornment>)
        }} variant="standard" sx={{ width: "50px" }} value={shopitem.price ?? 0} onChange={(e) => dispatch(setShopItem({ item: shopitem.item, shop: props.shopName, itemid: props.itemid, price: Number(e.currentTarget.value) }))} />
    </Box>
}